export default "__VITE_ASSET__kuMZjszS__"